#import "../fragments/email-attachment.graphql"

mutation CreateEmailSequence($emailSequence: EmailSequenceCreateInput!) {
    emailSequenceCreate(input: $emailSequence) {
        emailSequence {
            id
            emailsQueued {
                id
                subject
                attachments {
                    ...EmailAttachment
                }
            }
        }
    }
}
